var __TEMP__ = require('./_apply.js');var apply = __REQUIRE_DEFAULT__(__TEMP__);
var __TEMP__ = require('./_createCtor.js');var createCtor = __REQUIRE_DEFAULT__(__TEMP__);
var __TEMP__ = require('./_createHybrid.js');var createHybrid = __REQUIRE_DEFAULT__(__TEMP__);
var __TEMP__ = require('./_createRecurry.js');var createRecurry = __REQUIRE_DEFAULT__(__TEMP__);
var __TEMP__ = require('./_getHolder.js');var getHolder = __REQUIRE_DEFAULT__(__TEMP__);
var __TEMP__ = require('./_replaceHolders.js');var replaceHolders = __REQUIRE_DEFAULT__(__TEMP__);
var __TEMP__ = require('./_root.js');var root = __REQUIRE_DEFAULT__(__TEMP__);

/**
 * Creates a function that wraps `func` to enable currying.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {number} arity The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */
function createCurry(func, bitmask, arity) {
  var Ctor = createCtor(func);

  function wrapper() {
    var length = arguments.length,
        args = Array(length),
        index = length,
        placeholder = getHolder(wrapper);

    while (index--) {
      args[index] = arguments[index];
    }
    var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
      ? []
      : replaceHolders(args, placeholder);

    length -= holders.length;
    if (length < arity) {
      return createRecurry(
        func, bitmask, createHybrid, wrapper.placeholder, undefined,
        args, holders, undefined, undefined, arity - length);
    }
    var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
    return apply(fn, this, args);
  }
  return wrapper;
}

if (!exports.__esModule) Object.defineProperty(exports, "__esModule", { value: true });exports.default = createCurry;
